import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { getLogoClaimConfig } from '@/src/app/components/Logo/logo.utils.ts';
import { transformURLForFrontendPaths } from '@/src/lib/utils/url.ts';

function LogoClaim({ className, lang, country }: { className?: string; lang: string; country: string }) {
  const config = getLogoClaimConfig();

  return (
    <Link href={transformURLForFrontendPaths('/', lang, country)} data-testid="logo" className="px-6 inline-block">
      <span className="sr-only">{config.name}</span>
      <Image
        className={classNames(config.className, className)}
        src={config.path}
        alt={`${config.name} Logo`}
        width={config.intrinsicWidth}
        height="52"
      />
    </Link>
  );
}

export default LogoClaim;
